module.exports = __webpack_public_path__ + "static/img/01.32c84ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/01.jpg
// module id = BOhW
// module chunks = 0